import { inject, Injectable } from '@angular/core';
import { Translation, TranslocoLoader } from '@jsverse/transloco';
import { HttpClient } from '@angular/common/http';
import { VERSION } from './version';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  private http = inject(HttpClient);

  getTranslation(lang: string) {
    // Translation files share the assets' `Cache-Control: immutable` policy on a
    // stable URL, so a returning client would pin a stale copy and miss new keys.
    // Keying the URL on the build commit fetches fresh JSON on every deploy.
    return this.http.get<Translation>(`./assets/i18n/${lang}.json?v=${VERSION.commit}`);
  }
}
